export default import.meta.ROLLDOWN_FILE_URL_JMuqLieGkTuy98pBWzN6FA